/**
 * DocViewSchema for Storefront Theme DocType
 * 
 * Single section with the theme token editor widget.
 */

import type { DocViewSchema } from "./types";

export const storefrontThemeDocViewSchema: DocViewSchema = {
  doctype: "Storefront Theme",
  views: {
    experience: {
      style: "shopify",
      sections: [
        {
          id: "theme-editor",
          label: "Theme Tokens",
          description: "Edit theme token values (colors, radius)",
          widgetId: "StorefrontThemeEditorWidget",
        },
      ],
      tabs: [
        {
          id: "details",
          label: "Details",
          sectionIds: ["theme-editor"],
        },
      ],
      quickActions: [],
      connectionGroups: [],
    },
  },
};
